import { render } from "./CodeOfConductView.vue?vue&type=template&id=f5565686"
import script from "./CodeOfConductView.vue?vue&type=script&lang=js"
export * from "./CodeOfConductView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__